import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import GlobalHelper from "../../common/GlobalHelper.jsx"
import { AppContext, Features, AccountFeatures } from "@lightspeed-invoicing/core-client/frontend"
import Icon from "../../common/icon/icon.component.jsx"
import LinkTemplateWrapper from "../../common/rich-text/feature-protection-wrappers/linkTemplateWrapper.component"

const SmsTemplatesSection = () => {
    const getLinks = () => {
        return ([
            {
                name: "quotes",
                to: "/settings/sms-templates/send-sms-quote/listing",
                module: "",
                message: <FormattedMessage
                    id="settings.sms.template.edit_sms_quote_name"
                    defaultMessage="Edit Quote SMS Template"
                />
            },
            {
                name: "orders",
                to: "/settings/sms-templates/send-sms-order/listing",
                module: AccountFeatures.FeatureOrder,
                message: <FormattedMessage
                    id="settings.sms.template.edit_sms_order_name"
                    defaultMessage="Edit Order SMS Template"
                />
            },
            {
                name: "invoices",
                to: "/settings/sms-templates/send-sms-invoice/listing",
                module: Features.Invoice,
                message: <FormattedMessage
                    id="settings.sms.template.edit_sms_invoice_name"
                    defaultMessage="Edit Invoice SMS Template"
                />
            }
        ])
    }

    const supportedDocuments = GlobalHelper.getSupportedDocuments()

    return (
        <div>
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-8">
                            <h2 className="m-0 custom-lead">
                                <FormattedMessage
                                    id="settings.sms.template.title"
                                    defaultMessage="SMS templates"
                                />
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row ui-has-modules">
                <div className="col-12 ui-module">
                    <div className="row" style={{paddingLeft: "20px"}}>
                        <div className="col-12 list-group">
                            {getLinks().filter(l => supportedDocuments.includes(l.name)).map((elem, index) => {
                                return <LinkTemplateWrapper
                                    key={index}
                                    module={elem.module}
                                    to={elem.to}
                                    redirectToAccount={true}
                                    className={"list-group-item"}
                                    protectedClassName={"list-group-item"}
                                    premium={false}
                                    protectionRule={elem.module === "" ?
                                        AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms) :
                                        AppContext.accountFeatureIsEnabled(elem.module) &&
                                        AppContext.accountFeatureIsEnabled(AccountFeatures.FeatureSms)}
                                >
                                    <Icon value={"envelope"} className={"mr-1"}/>
                                    {elem.message}
                                    <Icon value={"chevron-right"}/>
                                </LinkTemplateWrapper>
                            })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default injectIntl(SmsTemplatesSection)


// WEBPACK FOOTER //
// ./src/settings/sms/SMSTemplateSection.tsx